/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesInfoNewsRequest interface.
 */
export function instanceOfFxIdWebFeaturesInfoNewsRequest(value) {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesInfoNewsRequestFromJSON(json) {
    return FxIdWebFeaturesInfoNewsRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesInfoNewsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'],
        'Locale': json['Locale'] == null ? undefined : json['Locale'],
    };
}
export function FxIdWebFeaturesInfoNewsRequestToJSON(json) {
    return FxIdWebFeaturesInfoNewsRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesInfoNewsRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
        'Locale': value['Locale'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesInfoNewsRequest.js.map